/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {ImmortalFruitSliderView} from "./ImmortalFruitSliderView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SlotApiEvent} from "@nolimitcity/slot-game/bin/core/slotapiadapter/event/SlotApiEvent";
import {GameFeatureNames} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/BonusFeatures";
import {ImmortalFruits} from "../ImmortalFruits";

export class ImmortalFruitConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000, //Default 0x000000
            backgroundAlpha:0.4, //Default 0.4
            bulletColor:0xffffff, //Default 0xffffff

        },
        stampColor:0xFFFFFF
    };

    stampConfig:StampConfig = {
        volatility:Volatility.EXTREME
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    constructor() {
        EventHandler.addEventListener(this, SlotApiEvent.BALANCE, (event: GameEvent) => this.checkFeatures());
    }
    private checkFeatures(){

    }
    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider2.png");
        imgLoader.add("feature1", "resources/images/Intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("feature2_USsweep","nolimit/screens/images/gambleWheel_USSweep.png");
        imgLoader.add("feature3_USsweep","nolimit/screens/images/gamble50_USSweep.png");
        imgLoader.add("feature3", "resources/images/intro_feature3.png");
        imgLoader.add("logo", "resources/images/introLogo.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);

        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

    }
    public gameClientConfigurationApplied() {
        let jackpotString:string = "Jackpot";
        if(ImmortalFruits.api.gameClientConfiguration.jurisdictionName==="ES" || ImmortalFruits.api.gameClientConfiguration.jurisdictionName==="LT" || ImmortalFruits.api.gameClientConfiguration.jurisdictionName==="PT"){ //#311
            jackpotString = "xWheelPot";
        }
        this.pages = [
            new ImmortalFruitSliderView("feature1", SlotGame.api.translations.translate(`xWheel feature with ${jackpotString} wins of x100, x250 and x2500 times your bet.`), 0x640c84),
        ];
        if (SlotGame.api.gameClientConfiguration.gambleFiftyFiftyAllowed) {
            this.pages.push(
               new SlideShowPage(ImgLoader.getImgTexture(ImmortalFruits.api.translations.language==="us-sweepstakes"?"feature3_USsweep":"feature3"),  SlotGame.api.translations.translate("Gamble your winnings in 50/50."),0x640c84),
            );
        }
        if (SlotGame.api.gameClientConfiguration.gambleIntoBonusAllowed) {
            this.pages.push(
               new SlideShowPage(ImgLoader.getImgTexture(ImmortalFruits.api.translations.language==="us-sweepstakes"?"feature2_USsweep":"feature2"),  SlotGame.api.translations.translate("Gamble your winnings in Wheel of Bonus."),0x640c84),

            );
        }
    }

}
